<template>
    <div class="application-logo">
        <img class="application-logo__image" :src="imageSource" />
    </div>
</template>

<script>
export default {
    name: "application-logo",
    props: {
        version: {type: Object},
    },
    computed: {
        imageSource() {
            return this.version && this.version.icons && this.version.icons.length > 0
                ? this.version.icons[0].src
                : require("@/assets/images/logo.png");
        },
    },
};
</script>

<style lang="scss" scoped>
.application-logo::v-deep {
    .application-logo__image {
        @apply block w-full h-full;
    }
}
</style>
